// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-input{position:relative;z-index:1;width:100%}.select-input .form-control-xl{height:calc(1.6em + 1.734rem + 1.7px) !important}.select-input .position-relative .form-control{padding-right:0}.select-input button{background:none;margin-top:1px !important}.select-input button i{display:inline-block;margin-top:-3px;transition:.6s}.select-input button i.up{transform:rotateX(-180deg)}", ""]);
// Exports
module.exports = exports;
